export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/business_finance_law.0a83930.svg";